import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import request from "superagent";
import configure from "./configure/index.js";
import searchQuery, { legacyDefaultSearchQueryBody } from "./searchQuery/index.js";

var TypeaheadSearchResponseWrapper =
/*#__PURE__*/
function () {
  function TypeaheadSearchResponseWrapper(response) {
    _classCallCheck(this, TypeaheadSearchResponseWrapper);

    this.response = response;
  }

  _createClass(TypeaheadSearchResponseWrapper, [{
    key: "profiles",
    get: function get() {
      return this.response.body.data.search.profiles;
    }
  }]);

  return TypeaheadSearchResponseWrapper;
}();

var StorefrontClient =
/*#__PURE__*/
function () {
  function StorefrontClient() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, StorefrontClient);

    var _configure = configure(config),
        host = _configure.host;

    this.host = host;
  }

  _createClass(StorefrontClient, [{
    key: "search",
    value: function search() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$searchQueryBody = _ref.searchQueryBody,
          searchQueryBody = _ref$searchQueryBody === void 0 ? legacyDefaultSearchQueryBody : _ref$searchQueryBody,
          typeAhead = _ref.typeAhead,
          _ref$filters = _ref.filters,
          filters = _ref$filters === void 0 ? [] : _ref$filters,
          limit = _ref.limit;

      var queryData = {
        query: searchQuery(searchQueryBody),
        variables: {
          typeAhead: typeAhead,
          filters: filters,
          limit: limit
        }
      };
      return request.post("".concat(this.host, "/graphql")).send(queryData).set('Accept', 'application/json').then(function (response) {
        return new TypeaheadSearchResponseWrapper(response);
      });
    }
  }]);

  return StorefrontClient;
}();

export { StorefrontClient as default };